import { render, staticRenderFns } from "./EquipmentAquarium.vue?vue&type=template&id=196ee28e&scoped=true"
import script from "./EquipmentAquarium.vue?vue&type=script&lang=ts"
export * from "./EquipmentAquarium.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentAquarium.vue?vue&type=style&index=0&id=196ee28e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ee28e",
  null
  
)

export default component.exports